export default __webpack_public_path__ + "static/media/que-step2.047eb724.gif";